import gql from 'graphql-tag';

export const membershipQuery = gql`
  query membershipQuery {
    member {
      id
      firstName
      lastName
      fianceFirstName
      fianceLastName
      email
      legacyUserId
      username
    }
  }
`;
